import React from "react";
import "./../styles/global.css";
import "react-quill/dist/quill.snow.css";
import ApplicationTop from "../components/Custom/ApplicationTop";
import CustomIndexPage from "./Custom/customindex";
import AboutPage from "./about";
import FaqPage from "./faq";
import BlogPostsPage from "./Custom/blog";
import DashboardPage from "./dashboard";
import CRMPage from "./Custom/crm";
import TrainingPage from "./Custom/training";
import TeamsPage from "./Custom/teams"
import HelpPage from "./Custom/help";
import AuthPage from "./auth";
import PackageInfoPage from "./Custom/packageinfo";
import SettingsPage from "./settings";
import LegalPage from "./legal";
import { Routes, Route, Router, Navigate } from "./../util/router";
import PurchasePage from "./purchase";
import FirebaseActionPage from "./firebase-action";
import NotFoundPage from "./404";
import MemberViewPage from "./Custom/memberview";
import CustomFooter from "../components/Custom/CustomFooter"
import { RouteChangeTracker } from "./../util/analytics";
import Chat from "./../components/Chat";
import { AuthProvider } from "./../util/auth";
import { QueryClientProvider } from "./../util/db";
import ClientViewPage from "./Custom/clientview";
import JoinTeamPage from "./Custom/jointeam";
import InfoPage from "./Custom/info";
import CalendarPage from "./Custom/calendar";
// import TestimonialsPage from "./Custom/testimonials";
import LandingPage from "./Custom/landing";
// import TempLandingPage from "./Custom/Temp.js/oct13landing";
import EbookPage from "./Custom/ebookpages";
// REMOVED: Lifetime/AIPP pages no longer offered
// import LifetimeLandingPage from "./Custom/Temp.js/LifetimeLandingPage";
import StairsBucketsLandingPage from "./Custom/landing/StairsBucketsLandingPage";
import AgencyTrainingOnboarding from "./Custom/onboarding/agency-training";
import StairsBucketsOnboarding from "./Custom/onboarding/stairs-buckets";
import WelcomeOnboarding from "./Custom/onboarding/welcome";
import CheckoutPage from "./checkout";
import SignupPage from "./signup";

import PublicHelpPage from "./Custom/publichelp";
import CookieConsentBanner from "../components/Custom/CookieBanner";
import SystemNotificationBanner from "../components/SystemNotificationBanner";
import LiveViewSection from "../components/Custom/LiveViewSection";
import Survey from "./Custom/survey.js";

function App(props) {
  return (
    <QueryClientProvider>
      <AuthProvider>
        <Chat />
        <Router>
          <>
            <RouteChangeTracker />
            <ApplicationTop bgColor="bg-white" type="Dashboard" />

            <SystemNotificationBanner />
            <LiveViewSection />

            <Routes>
              <Route path="/all" element={<CustomIndexPage />} />

              <Route path="/" element={<LandingPage />} />

              <Route path="/about" element={<AboutPage />} />

              {/* REMOVED: Lifetime product no longer offered
              <Route path="/bt/life" element={<LifetimeLandingPage />} />
              */}

              <Route path="/lp/stairs-buckets" element={<StairsBucketsLandingPage />} />

              <Route path="/ebooks/:ebookSlug/:status" element={<EbookPage />} />

              {/* <Route path="/testimonials" element={<TestimonialsPage />} /> */}

              <Route path="/view/member/:index" element={<MemberViewPage />} />

              <Route path="/blog/:index" element={<BlogPostsPage />} />

              <Route path="/packages/:section" element={<PackageInfoPage />} />

              <Route path="/faq" element={<FaqPage />} />

              {/* <Route path="/contact" element={<ContactPage />} /> */}

              {/* Old multi-option "Choose the best plan" shop is retired — funnel to All Packages */}
              <Route path="/pricing/:section" element={<Navigate to="/all" replace />} />
              <Route path="/pricing" element={<Navigate to="/all" replace />} />

              <Route path="/admin" element={<CRMPage />} />

              <Route path="/dashboard/:section" element={<DashboardPage />} />

              <Route path="/tools/:section" element={<TrainingPage />} />

              <Route path="/view/:code" element={<ClientViewPage />} />

              <Route path="/join/:code" element={<JoinTeamPage />} />

              <Route path="/teams/:id" element={<TeamsPage />} />

              <Route path="/settings/:section" element={<SettingsPage />} />

              <Route path="/help" element={<Navigate to="/help/faq" replace />} />

              <Route path="/help/:section" element={<HelpPage />} />

              <Route path="/auth/:type" element={<AuthPage />} />

              <Route path="/legal/:section" element={<LegalPage />} />

              <Route path="/support" element={<PublicHelpPage />} />

              <Route path="/purchase/:plan" element={<PurchasePage />} />

              <Route path="/checkout" element={<CheckoutPage />} />

              <Route path="/info/:type" element={<InfoPage />} />

              <Route path="/calendar" element={<CalendarPage />} />

              <Route path="/survey/:surveyName" element={<Survey />} />

              <Route path="/onboarding/agency-training" element={<AgencyTrainingOnboarding />} />
              <Route path="/onboarding/stairs-buckets" element={<StairsBucketsOnboarding />} />
              <Route path="/onboarding/welcome" element={<WelcomeOnboarding />} />

              <Route path="/signup" element={<SignupPage />} />

              <Route
                path="/firebase-action"
                element={<FirebaseActionPage />}
              />

              <Route path="*" element={<NotFoundPage />} />
            </Routes>
            <CustomFooter />
            <CookieConsentBanner />

            {/* <Footer
              size="md"
              bgColor="bg-white"
              bgImage=""
              bgImageOpacity={1}
              textColor=""
              sticky={true}
            /> */}
          </>
        </Router>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
